(function () {
    'use strict';

    angular.module("imApp").factory("poFinishProdWorkService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 264,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
